<script setup>
import ProcessStep from '@/components/ui/ProcessStep.vue'

/**
 * LandingProcess V3 - Timeline Design
 *
 * Migrated from public/prototypes/landing-v3-storytelling.html
 * Vertical timeline with 4 steps and real timeframes
 */

const steps = [
  {
    number: 1,
    title: 'Registro y pago',
    duration: '5 minutos',
    description: 'Creas tu cuenta, eliges tu servicio y proporcionas la información sobre tu caso.',
    note: null
  },
  {
    number: 2,
    title: 'Análisis de viabilidad',
    duration: '72h hábiles',
    description: 'Nuestro equipo legal analiza tu caso y valora su viabilidad jurídica conforme al RGPD art. 17, evaluando de forma individualizada cada plataforma y publicación. El análisis determina si existen fundamentos legales suficientes para solicitar la supresión.',
    note: {
      type: 'success',
      text: 'Si se determina que no existen fundamentos legales suficientes, reembolso 100%'
    }
  },
  {
    number: 3,
    title: 'Preparación y envío',
    duration: '48-72h',
    description: 'Generamos los documentos legales personalizados y enviamos las solicitudes a las URLs indicadas.',
    note: null
  },
  {
    number: 4,
    title: 'Seguimiento y resolución',
    duration: '30-45 días',
    description: 'Monitorizamos todas las respuestas y el estado de tu solicitud. Conforme al RGPD, artículo 12, las organizaciones deben responder en el plazo general de un mes, con posibilidad de ampliación en casos complejos.',
    note: {
      type: 'info',
      text: 'En caso de denegación injustificada y previa valoración jurídica, el servicio puede incluir la presentación de reclamación ante la AEPD.'
    }
  }
]
</script>

<template>
  <section id="proceso" class="py-24 bg-white">
    <div class="max-w-5xl mx-auto px-6">
      <!-- Section Header -->
      <div class="text-center mb-20">
        <span class="text-sm font-semibold text-accent-600 uppercase tracking-widest mb-4 block">Como funciona</span>
        <h2 class="text-4xl md:text-5xl font-bold text-text-primary mb-6">
          Proceso transparente, plazos reales
        </h2>
        <p class="text-xl text-text-secondary max-w-2xl mx-auto">
          Sin promesas vacias. Te explicamos exactamente que esperar en cada etapa.
        </p>
      </div>

      <!-- Timeline -->
      <div class="timeline-connector space-y-8">
        <ProcessStep
          v-for="(step, index) in steps"
          :key="step.number"
          :number="step.number"
          :title="step.title"
          :duration="step.duration"
          :description="step.description"
          :note="step.note"
          :isLast="index === steps.length - 1"
        />
      </div>
    </div>
  </section>
</template>

<style scoped>
@reference "../../assets/styles/main.css";

/* timeline-connector is defined in main.css */
</style>
